import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { cleanSession } from '@/components/sessionSlice';
import { useNavigate } from 'react-router-dom';

const cleanStore = () => (dispatch) => Promise.all([dispatch(cleanSession(null))]);

const SignOutView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const actions = bindActionCreators({ cleanStore }, dispatch);
  const signOut = () => {
    navigate('/login');
  };

  useEffect(() => {
    setTimeout(() => {
      actions.cleanStore().then(signOut);
    }, 1500);
  }, []);

  return <div>Signing out...</div>;
};

export default React.memo(SignOutView);
